import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import SlideUpPopup from "../../../../generic/slideUpPopup";
import HoldEqUnusablePopup from "./holdEqUnusablePopup";

export interface IHoldEqUnusableRowMobProps {
	rowData: any;
}

const HoldEqUnusableRowMob: React.FC<IHoldEqUnusableRowMobProps> = props => {
	const [isPopupOpen, setIsPopupOpen] = React.useState(false);

	return (
		<>
			<li className="data_row" onClick={() => setIsPopupOpen(true)}>
				<div className="row1">
					<div className="col trdSym">
						<span dangerouslySetInnerHTML={{ __html: props.rowData.companyName }}></span>
					</div>
					<div className="col ltp">LTP: ₹{toINR(props.rowData.LTP)}</div>
				</div>
				<div className="row2">
					<div className="col totQty">Pledged Qty: {props.rowData.pledgQty}</div>
					<div className="col totQty">Locked-in Qty: {toINR(props.rowData.lockedInQty)}</div>
				</div>
			</li>

			{isPopupOpen && (
				<SlideUpPopup closePopup={() => setIsPopupOpen(false)}>
					<HoldEqUnusablePopup data={props.rowData} onClose={() => setIsPopupOpen(false)} />
				</SlideUpPopup>
			)}
		</>
	);
};

export default HoldEqUnusableRowMob;
